'use client';

import { FC, useEffect, useState } from 'react';

import { SearchResult } from 'minisearch';

import { getCountryCharges } from '@/components/mini-apps/intl-charges/actions';
import { Section } from '@/components/momentum/components/section';
import { StoryblokComponentProps } from '@/storyblok/engine';

import { CountryRates, SearchBox, SearchResults } from './components';
import { IntlCallRatesContent } from './types';

export interface InternationalChargesProps {
  StoryblokComponent?: FC<StoryblokComponentProps>;
}

export const InternationalCharges: FC<InternationalChargesProps> = ({
  StoryblokComponent,
}) => {
  const [searchResults, setSearchResults] = useState<Array<SearchResult>>();
  const [selectedCountry, setSelectedCountry] = useState<SearchResult>();
  const [selectedData, setSelectedData] = useState<IntlCallRatesContent>();

  useEffect(() => {
    if (searchResults && searchResults.length > 0) {
      setSelectedCountry(searchResults[0]);
    }
  }, [searchResults]);

  useEffect(() => {
    selectedCountry
      ? getCountryCharges(selectedCountry.slug).then((story) =>
          setSelectedData(story as IntlCallRatesContent)
        )
      : setSelectedData(undefined);
  }, [selectedCountry]);

  return (
    <>
      <Section
        verticalRhythm={'md'}
        layout={'spacious'}
        reducedSpacing={'bottom'}
      >
        <SearchBox
          setSelectedCountry={setSelectedCountry}
          setSelectedData={setSelectedData}
          setSearchResults={setSearchResults}
        />
      </Section>

      {searchResults && (
        <Section
          verticalRhythm={'md'}
          layout={'spacious'}
          reducedSpacing={'bottom'}
        >
          <SearchResults
            searchResults={searchResults}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
          />
        </Section>
      )}

      {selectedData && (
        <Section
          verticalRhythm={'md'}
          layout={'spacious'}
          reducedSpacing={'bottom'}
        >
          <CountryRates
            blok={selectedData.content}
            StoryblokComponent={StoryblokComponent!}
          />
        </Section>
      )}
    </>
  );
};
